import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../components/Layout";
import { useTranslation } from "react-i18next";
import FieldTechniciansContent from "../../components/Pages/FieldTechnicians";

const { displayName } = config;

export default function FieldTechnicians(): React.ReactNode | null {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${displayName}: Field Technicians`;
  }, []);

  return (
    <Layout title="List of Field Technicians">
      <FieldTechniciansContent />
    </Layout>
  );
}
